// Initialize swatch hover functionality
class SwatchImageHandler {
  constructor() {
    this.initializeSwatches();
  }

  initializeSwatches() {
    const swatches = document.querySelectorAll('.swatch');
    
    swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.handleSwatchEnter.bind(this));
      swatch.addEventListener('mouseleave', this.handleSwatchLeave.bind(this));
    });
  }

  handleSwatchEnter(event) {
    const swatch = event.target;
    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    const mainImage = card.querySelector('.main-product-image');
    if (!mainImage) return;

    const variantImage = swatch.dataset.variantImage;
    if (!variantImage) return;

    // Store all original image attributes
    if (!mainImage.dataset.originalSrc) {
      mainImage.dataset.originalSrc = mainImage.src;
      mainImage.dataset.originalSrcset = mainImage.srcset;
      mainImage.dataset.originalSizes = mainImage.sizes;
    }

    // Update image with variant image
    // Create a srcset for the variant image following the same pattern as original
    const widths = [165, 360, 533, 720, 940, 1066];
    const variantSrcset = widths
      .map(width => {
        const variantUrl = this.generateVariantImageUrl(variantImage, width);
        return `${variantUrl} ${width}w`;
      })
      .join(', ');

    mainImage.src = variantImage;
    mainImage.srcset = variantSrcset;
  }

  handleSwatchLeave(event) {
    const swatch = event.target;
    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    const mainImage = card.querySelector('.main-product-image');
    if (!mainImage) return;

    // Restore original image attributes
    if (mainImage.dataset.originalSrc) {
      mainImage.src = mainImage.dataset.originalSrc;
      mainImage.srcset = mainImage.dataset.originalSrcset;
      mainImage.sizes = mainImage.dataset.originalSizes;
    }
  }

  generateVariantImageUrl(baseUrl, width) {
    // Extract the base URL without size parameters
    const urlWithoutSize = baseUrl.replace(/_\d+x\./, '.');
    // Insert new size
    return urlWithoutSize.replace(/\.(jpg|jpeg|png|gif)/, `_${width}x.$1`);
  }
}

// Initialize the handler
document.addEventListener('DOMContentLoaded', () => {
  new SwatchImageHandler();
});